<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs11 sm7 md3>
            <div class="text-xs-center" style="margin-bottom:15px;">
              <img src="../../../assets/images/arkman.png" alt="Arkman">
            </div>
            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step step="1" :complete="e1 > 1">Giriş</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="2" :complete="e1 > 2">Ana Şirket</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="3">Şirket</v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>

                <v-alert type="error" :value="true" v-model="errorAlert" transition="scale-transition">
                  <span>{{ errorMsg }}</span>
                </v-alert>
                <v-stepper-content style="background-color:#E0E0E0;" step="1">
                  <v-container fluid>
                    <v-form>
                      <v-layout v-if="loginstatus" row wrap>
                        <v-flex sm12 md12>
                          <v-layout align-center justify-end row fill-height>
                            <v-btn flat @click="newUser()" color="primary">Kayıt Ol &nbsp;
                              <v-icon>group_add</v-icon>
                            </v-btn>
                          </v-layout>
                        </v-flex>
                        <v-flex sm12 md12>
                          <v-text-field prepend-icon="person" box="" placeholder="Kullanıcı Adı" name="email"
                            v-model="Credential.email" label="Email" type="text" :rules="[rules.required, rules.email]">
                          </v-text-field>
                        </v-flex>
                        <v-flex sm12 md12>
                          <v-text-field prepend-icon="lock" box="" placeholder="Şifre" name="password"
                            v-model="Credential.password" label="Şifre" id="password" v-on:keyup.13="apiLogin"
                            :type="e2 ? 'password' : 'text'" :rules="[rules.required]"
                            :append-icon="e2 ? 'visibility' : 'visibility_off'" :append-icon-cb="() => (e2 = !e2)">
                          </v-text-field>
                        </v-flex>
                        <v-flex sm12 md12>
                          <v-btn color="info" @click="apiLogin">Giriş</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-form>
                    <v-form ref="formnewuserstatus" v-model="valid">
                      <v-layout v-if="newuserstatus" row wrap>

                        <v-flex sm12 md12>
                          <v-layout align-center justify-center="" row fill-height>
                            <div> <strong class="title primary--text">Yeni Kullanıcı Bilgileri</strong></div>
                          </v-layout>
                        </v-flex>

                        <v-flex sm12 md12>
                          <v-text-field prepend-icon="subtitles" box="" :rules="[rules.required]" placeholder="Ünvan"
                            v-model="unvan" label="Ünvan"></v-text-field>
                        </v-flex>
                        <v-flex sm12 md12>
                          <v-text-field prepend-icon="person" box="" :rules="[rules.required]" placeholder="Ad Soyad"
                            v-model="YeniKullanici.AdSoyad" label="Ad Soyad"></v-text-field>
                        </v-flex>

                        <v-flex sm12 md12>
                          <v-text-field prepend-icon="email" box="" placeholder="E-mail" v-model="YeniKullanici.email"
                            label="Email" type="text" :rules="[rules.required, rules.email]"></v-text-field>
                        </v-flex>
                        <v-flex sm12 md12>
                          <v-text-field prepend-icon="lock" box="" counter="8" placeholder="Şifre"
                            v-model="YeniKullanici.Sifre" label="Şifre" id="password1" :type="e3 ? 'password' : 'text'"
                            :rules="[rules.required]" :append-icon="e3 ? 'visibility' : 'visibility_off'"
                            :append-icon-cb="() => (e3 = !e3)"></v-text-field>
                        </v-flex>
                        <v-flex sm12 md12>
                          <v-text-field prepend-icon="lock" box="" counter="8" placeholder="Şifre Tekrar"
                            v-model="confirm" label="Şifre" id="password2" :type="e4 ? 'password' : 'text'"
                            :rules="[rules.required]" :append-icon="e4 ? 'visibility' : 'visibility_off'"
                            :append-icon-cb="() => (e4 = !e4)"></v-text-field>
                        </v-flex>
                        <v-flex>
                          <v-btn color="info" @click="geriDon()">Geri Dön</v-btn>
                          <v-btn color="info" @click="saveUser()">Kayıt Ol</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-stepper-content>
                <v-stepper-content style="background-color:#E0E0E0;" step="2">
                  <v-flex style="height:80px;">
                    <v-select hint="Ana şirketinizi seçiniz" autofocus v-on:keyup.13="anaSirketIleri" persistent-hint
                      :items="AnaSirketler" v-model="AnaSirket" single-line bottom></v-select>
                  </v-flex>
                  <v-btn color="info" @click="anaSirketIleri">İLERİ</v-btn>
                </v-stepper-content>
                <v-stepper-content style="background-color:#E0E0E0;" step="3">
                  <v-flex style="height:80px;">
                    <v-select :items="Sirketler" hint="Şirketinizi seçiniz" persistent-hint v-model="Sirket" single-line
                      bottom></v-select>
                  </v-flex>
                  <v-btn color="info" @click.native="e1 = 2">GERİ</v-btn>
                  <v-btn color="info" @click="sysLogin">Devam Et</v-btn>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-flex>
        </v-layout>
      </v-container>
      <template>
        <v-card>
          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
          </v-snackbar>
        </v-card>
      </template>

    </v-content>
  </v-app>




</template>

<script>
  import auth from '../../../api/auth'
  import _ from 'underscore'
  import router from '../../../router'

  export default {
    data: () => ({
      faturainfo: [],
      newuserstatus: false,
      loginstatus: true,
      drawer: null,
      e1: 0,
      e2: true,
      e3: true,
      e4: true,
      text1: '',
      snackbar: false,
      y: 'top',
      x: 'right',
      mode: '',
      timeout: 6000,
      rules: {
        required: (value) => !!value || 'Gerekli alan.',
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Hatalı e-mail.'
        }
      },
      YeniKullanici: {
        UserID: null,
        MusteriID: 0,
        KullaniciAdi: null,
        Email: null,
        Sifre: null,
        Tip: 0,
        AdSoyad: null,
        Deleted: false,
        Aktif: true,
        MusteriBilgi: [],

      },
      unvan: null,
      confirm: null,
      Credential: {
        email: '',
        password: ''
      },
      valid: true,
      errorMsg: '',
      errorAlert: false,
      AnaSirketler: [],
      Sirketler: [],
      AnaSirket: {},
      Sirket: {}
    }),
    props: {
      source: String
    },
    methods: {

      apiLogin,
      sysLogin,
      anaSirketIleri,
      newUser,
      geriDon,
      saveUser
    }
  }

  function saveUser() {
    if (this.$refs.formnewuserstatus.validate()) {
      if (this.YeniKullanici.Sifre == this.confirm) {

        var musteribilgi = {
          Ad: this.unvan
        }
        var musteribilgiler = [];
        musteribilgiler.push(musteribilgi)
        this.YeniKullanici.MusteriBilgi = musteribilgiler
        var params1 = this.YeniKullanici;

        this.$http.post(auth.API_URL + 'api/Register/Create', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          if (response.body.Status == true) {

            this.errorMsg = 'Kayıt işlemi gerçekleşti. Giriş yapınız..';
            this.errorAlert = true;
            this.newuserstatus = false;
            this.loginstatus = true;

          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Yeni Kullanıcı'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Yeni Kullanıcı'
            this.snackbar = true
          }
        })


      } else {
        this.errorMsg = 'Şifreler aynı değil';
        this.errorAlert = true;
      }

    } else {
      console.log('form validate değil')
    }
  }

  function geriDon() {
    this.newuserstatus = false;
    this.loginstatus = true;
  }

  function newUser() {
    this.newuserstatus = true;
    this.loginstatus = false;
  }

  function apiLogin() {
    var credential = {
      Email: this.Credential.email,
      Password: this.Credential.password
    }
    auth.login(this, credential, this.$route.query.redirect)
  }

  function sysLogin() {

    var earsiv = 0
    var efatura = 0
    var response = JSON.parse(window.localStorage.getItem('response'));
    var sirketler = JSON.parse(window.localStorage.getItem('sirketler'));

    window.localStorage.setItem('token', response.Token.token);

    var sirketparams = {
      SirketKodu: this.Sirket.id
    }
    this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', sirketparams, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {


      earsiv = response.body.OpsiyonBilgileri.EArsiv
      efatura = response.body.OpsiyonBilgileri.EFaturaKullaniyor

      var credentials = {
        AnaSirketKodu: this.AnaSirket.id,
        SirketKodu: this.Sirket.id,
        SirketAdi: this.Sirket.text,
        SirketUnvani: this.Sirket.unvan,
        Sirketler: sirketler,
        EArsiv: earsiv,
        EFatura: efatura
      }


      window.localStorage.setItem('credentials', JSON.stringify(credentials));



    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Company Get'
        this.snackbar = true
        this.load1 = true
        this.progress = false

        var credentials = {
          AnaSirketKodu: this.AnaSirket.id,
          SirketKodu: this.Sirket.id,
          SirketAdi: this.Sirket.text,
          SirketUnvani: this.Sirket.unvan,
          Sirketler: sirketler,
          EArsiv: earsiv,
          EFatura: efatura
        }


        window.localStorage.setItem('credentials', JSON.stringify(credentials));
      } else {
        this.text1 = 'Service Unavailable-Company Get'
        this.snackbar = true
        this.load1 = true
        this.progress = false
        var credentials = {
          AnaSirketKodu: this.AnaSirket.id,
          SirketKodu: this.Sirket.id,
          SirketAdi: this.Sirket.text,
          SirketUnvani: this.Sirket.unvan,
          Sirketler: sirketler,
          EArsiv: earsiv,
          EFatura: efatura
        }
        window.localStorage.setItem('credentials', JSON.stringify(credentials));
      }
    })

    window.localStorage.removeItem('response')
    window.localStorage.removeItem('sirketler')

    router.push({
      path: '/'
    })
  }

  function anaSirketIleri() {

    var response = JSON.parse(window.localStorage.getItem('response'));

    var anaSirketBilgiler = _.findWhere(response.MusteriDbler, {
      MusteriKod: this.AnaSirket.id
    })

    if (anaSirketBilgiler.GenelSirketler.length === 0) {
      this.errorAlert = true;
      this.errorMsg = "Kayıtlı şirketler bulunamadı";
      this.e1 = 2;
    } else {
      this.errorAlert = false;
      this.e1 = 3;

      var sirketler = [];

      Object.keys(anaSirketBilgiler.GenelSirketler).forEach(key => {
        var sirket = {
          text: anaSirketBilgiler.GenelSirketler[key].SirketAdi,
          id: anaSirketBilgiler.GenelSirketler[key].SirketKodu,
          unvan: anaSirketBilgiler.GenelSirketler[key].SirketUnvani
        }
        sirketler.push(sirket)
      });
      window.localStorage.setItem('sirketler', JSON.stringify(sirketler));
      this.Sirketler = sirketler;
      this.Sirket = sirketler[0];
    }

  }
</script>